import { ReactNode } from "react"
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material"

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#1976d2" }
  },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, sans-serif'
  }
})

export default function AppLayout({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
